export default {
	AGUARDANDO: { value: 'AGUARDANDO', text: 'Em Processamento' },
	ERRO: { value: 'ERRO', text: 'Erro' },
	SINCRONIZADO: { value: 'SINCRONIZADO', text: 'Finalizado' },
}
